import UnhandledErrorScreen from 'components/UnhandledErrorScreen/UnhandledErrorScreen.component';

export default UnhandledErrorScreen;
